<template>
  <div class="invite">
    <div class="banner">
      <div>
        <p>邀请码：{{this.userid}}</p>
        <p>请在用户中心绑定师傅的邀请码</p>
      </div>
      <div @click="download()"></div>
    </div>
    <div class="line"></div>
    <ul class="invite_users">
      <li v-for="(item, key) in users" :key="key">
        <div class="content">
          <div class="content_l">
            <div class="ahaver"><img :src="item.avatar"/></div>
            <div class="description">
              <p>{{item.nickname}}</p>
              <p>成功领取<span>{{item.money_txt}}</span>元微信红包</p>
            </div>
          </div>
          <div class="content_r">
            {{item.time}}
          </div>
        </div>
      </li>
    </ul>
    <div class="shadow" v-show="isShow">
      <div></div>
    </div>

    <!--谨防诈骗提醒弹窗-->
		<van-dialog v-model="warningShow" :showConfirmButton=false width="3rem" :closeOnClickOverlay=true>
			<div class="warning_dialog">
				<div class="warning_dialog_block">
          <span>
            <img src="@/assets/images/invite_warning.png" />
          </span>
          <span>谨防诈骗</span>
					<span>本平台不会收取任何费用，凡是要转账汇款的，都是电信诈骗！切勿上当！</span>
					<span @click="warningShow = false">好的，知道了</span>
				</div>
			</div>
		</van-dialog>

  </div>
</template>

<style>
  body {
    background-color: #ffe1d7;
  }
</style>

<style lang="less" scoped>
  .invite {
    display: block;
    width: 3.75rem;
    background-color: #ffe1d7;
    min-height: 100vh;
  }
  .banner {
    display: block;
    width: 100%;
    height: 5.17rem;
    background: url('~@/assets/images/invite_banner.png') no-repeat;
    background-size: 3.75rem 5.17rem;
    position: relative;
    overflow: hidden;
  }
  .banner div:first-child {
    display: block;
    width: 1.75rem;
    height: .6rem;
    margin: 0 auto;
    margin-top: 3.1rem;
    overflow: hidden;
  }
  .banner div:first-child p:first-child {
    display: block;
    width: 1.65rem;
    height: .35rem;
    margin: 0 auto;
    background: url('~@/assets/images/invite_code_bg.png');
    background-size: 1.65rem .35rem;
    line-height: .35rem;
    text-align: center;
    color: #e98474;
    font-size: 16px;
    overflow: hidden;
  }
  .banner div:first-child p:last-child {
    display: block;
    width: 100%;
    text-align: center;
    color: #e98474;
    font-size: 12px;
    overflow: hidden;
  }
  .banner div:last-child {
    display: block;
    width: 2rem;
    height: .6rem;
    margin: 0 auto;
    margin-top: 0.3rem;
    overflow: hidden;
  }
  .line {
    display: block;
    width: 100%;
    height: .32rem;
    background: url('~@/assets/images/invite_split.png') no-repeat;
    background-size: 3.75rem .32rem;
    overflow: hidden;
  }
  .invite_users {
    display: block;
    width: 3.3rem;
    height: auto;
    margin: 0 auto;
    margin-bottom: .15rem;
    overflow: hidden;
  }
  .invite_users li {
    display: flex;
    clear: both;
    width: 100%;
    height: .78rem;
    background: #f94f33;
    border-radius: .08rem;
    margin-top: .1rem;
    align-items: center;
    overflow: hidden;
  }
  .invite_users li .content{
    display: flex;
    width: 100%;
    height: .48rem;
    justify-content: space-around;
    overflow: hidden;
  }
  .invite_users li .content .content_l {
    display: flex;
    height: .48rem;
    align-items: flex-start;
    overflow: hidden;
  }
  .invite_users li .content .content_l .ahaver {
    display: block;
    width: .44rem;
    height: .44rem;
    border: 2px solid #fff;
    border-radius: 100%;
    overflow: hidden;;
  }
  .invite_users li .content .content_l .ahaver img {
    width: 100%;
  }
  .invite_users li .content .content_l .description {
    display: flex;
    float: left;
    margin-left: .15rem;
    height: .48rem;
    flex-direction: column;
    justify-content: space-around;
  }
  .invite_users li .content .content_l .description p {
    display: inline-block;
    line-height: 0;
  }
  .invite_users li .content .content_l .description p:first-child {
    font-size: 16px;
    color: #ffe578;
  }
  .invite_users li .content .content_l .description p:last-child {
    color: #FFF;
    font-size: 14px;
  }
  .invite_users li .content .content_l .description p:last-child span {
    font-size: 16px;
    color: #ffe578;
  }
  .invite_users li .content .content_r {
    display: block;
    float: right;
    height: .48rem;
    color: #FFF;
    font-size: 14px;
    overflow: hidden;
  }
  .shadow {
    display: block;
    width: 100%;
    height: 100vh;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.6);
    top: 0;
  }
  .shadow div {
    display: block;
    width: 1.5rem;
    height: 1rem;
    background: url('~@/assets/images/tips.png') no-repeat;
    background-size: 1.5rem 1rem;
    float: right;
    margin-top: .1rem;
    margin-right: .1rem;
    overflow: hidden;
  }
  /** 谨防诈骗提醒弹窗样式 */
  /deep/ .van-dialog{
			border-radius: .06rem;
  }
	.warning_dialog {
		display: flex;
		width: 3rem;
		z-index: 2;
		.warning_dialog_block {
			position: relative;
			display: flex;
			flex-flow: column;
			width: 2.56rem;
			background-color: #fff;
			padding: .24rem;
      color: #333;
      justify-content: center;
      text-align: center;
      span:first-child {
        margin-bottom: .18rem;
        img {
          width: .58rem;
          height: .58rem;
        }
			}
			span:nth-child(2) {
				text-align: center;
				font-size: .24rem;
				font-weight: 600;
        padding-bottom: .16rem;
        color: #333;
			}
			span:nth-child(3) {
				display: block;
				font-size: .14rem;
				padding-bottom: .26rem;
        line-height: .22rem;
        color: #333;
        text-align: left;
			}
			span:last-child {
				cursor: pointer;
        display: block;
				width: 1.4rem;
				margin: 0 .56rem;
				height: .42rem;
				line-height: .42rem;
				background: #FF7F4B;
				border-radius: .21rem;
				text-align: center;
				font-size: .14rem;
				color: #fff;
			}
		}
	}
</style>

<script>
import Vue from 'vue'
import { Dialog } from 'vant'
Vue.use(Dialog)

export default {
  created() {
    document.title = '一亿人在玩的兼职赚钱APP'
    this.userid = this.$route.query.userid
    this.appIdCode = this.$route.query.app_id_code
    this.getInviteUser()
  },
  data() {
    return {
      userid: '',
      appIdCode: '',
      inviteCode: '00000000',
      users: [],
      downPath: '',
      isShow: false,
      warningShow: true,
    }
  },
  methods: {
    getInviteUser: function () {
      let params = {
        userid: this.userid
      }
      
      this.isLoad = true
      this.$http.get('/api/user_web/share_page', {params: params}).then((res) => {
        this.users = res.data.list
      })
    },
    download: function () {
      let ua = navigator.userAgent.toLowerCase()
      // let host = location.hostname
      // let protocol = location.protocol
      // let domain = protocol + '//' + host

      if(ua.match(/MicroMessenger/i)=="micromessenger") {
        this.isShow = true
      } else {
        location.href = "https://game.ahaozhuan.com/api/user_web/share_down_package?userid=" + this.userid + "&package_type=2" + "&app_id_code=" + this.appIdCode;
      }
    }
  }
}
</script>